import moment from 'moment';
import { AlertCircle, Anchor, Clock, Minus, Star } from 'react-feather';
import {
    addDays, addMonths, addWeeks, addYears
} from 'date-fns';
import Text from '../atoms/Text';
import commonDropdownStyle from './commonDropDownStyles';
import codes from './countryCode';
import { isImmDate } from '@/helper/irs.helper.service';
import { Activity, Category, Chart, Diagram, Speedometer, StatusUp, TrendUp } from 'iconsax-react';
import HoverText from '@/organisms/Irs/HoverText';

export const traderTypes = ['Bank', 'RM', 'HF', 'PB'];
export const complianceRoles = ['Compliance', 'Operation'];

export const countryCodes = codes;

export const tradeTypes = {
    Bid: {
        action: 'hit',
        type: 'bid'
    },
    Offer: {
        action: 'lift',
        type: 'offer'
    }
};
export const prefixes = ['plot'];

export const popupSpecs = 'width=800,height=2000,left=0,popup';
export const popupSpecsForDes = 'width=1480,height=2000,left=0,popup';
export const popupSpecsForMatch = 'width=1200,height=2000,left=0,popup';
export const popupSpecsForDownloadOrders = 'width=1104,height=1024,left=0,popup';
export const popupSpecsForTrade = 'width=1320,height=2000,left=0,popup';
export const popupSpecsForQuickPrice = 'width=1480,height=2000,left=0,popup';
export const windowFeatures = 'popup=true,left=0,top=0,right=0,bottom=0,width=528,height=2000';
export const commandPromptIds = {
    devlopment: '0193f258-e1e9-766c-bec9-722df5be573a',
    qa: '0193f258-e1e9-766c-bec9-722df5be573a',
    uat: '01934ffe-3bb5-700f-a8ef-d2f52c9cd125',
    'production-sandbox': '01938603-b654-7994-8a37-fca6ccaa38e3',
    production: '01937860-8417-7995-b35a-fd3a07e560f0',
    automation: '0193f258-e1e9-766c-bec9-722df5be573a'
};

export const isValidImageFormat = (format) => ['jpg', 'jpeg', 'png', 'svg'].includes(format?.toLowerCase());
export const isValidVideoFormat = (format) => ['mp4'].includes(format?.toLowerCase());
export const isValidFileFormat = (format) => ['pdf', 'txt', 'doc', 'docx', 'csv', 'xlsx', 'xls'].includes(format?.toLowerCase());

export const formatFileSize = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(decimals))} ${sizes[i]}`;
};
export const loaderDisabledPages = ['/', '/error', '/chat', '/bonds/create-bonds', '/agora', '/termandcondition', '/product',
    '/regulatoryInfo/DeonRuleBook', '/liveprices', '/liveprices/[type]', '/liveprices/[type]/[subType]', '/regulatoryInfo/matchingRule'
];

export const convertStringToFixedFloat = (number, decimalPlaces) => {
    let value = number;
    if (!value) return 0;
    if (typeof value === 'string') {
        value = parseFloat(value);
        if (isNaN(value)) {
            return 0;
        }
    }
    return Number(value.toFixed(decimalPlaces));
};
export const getSizeFormatter = (val) => {
    const format = (num, unit) => ({
        value: Number(Number(num.toPrecision(13)).toString()),
        unit
    });

    if (val >= 1000000000) return format(val / 1000000000, 'Bn');
    if (val >= 1000000) return format(val / 1000000, 'Mn');
    if (val >= 1000) return format(val / 1000, 'K');
    if (val > 0) return format(val / 1000, 'K');

    return { value: val, unit: '' };
};
export const getFormattedSize = (val) => {
    const { value, unit } = getSizeFormatter(val);
    return `${value}${unit}`;
};

export const textFormatter = {
    date1: (date) => moment(date, 'YYYY-MM-DD').format('ddd, Do MMM YYYY')
};
export const userActions = {
    sell: 'Buyer', buy: 'Seller', receive: 'Payer', pay: 'Receiver'
};
export const formatNumberWithComma = (value) => {
    if (!value) return '';
    if (Number.isNaN(Number(value))) {
        return value;
    }
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 6 }).format(value);
};

export const formatAmount = (amount) => new Intl.NumberFormat('en-US').format(amount);
export const rfqCounterTimer = 60000;
export const irsLiveTime = 2 * 60 * 1000;
export const currencyLiveTime = 2 * 60 * 1000;
export const NdfDefaultCurrency = 'USD';
export const irsTenureValues = {
    d: 1, D: 1, w: 2, W: 2, m: 3, M: 3, y: 4, Y: 4
};
export const irsTerms = ['1 W', '2 W', '1 M', '3 M', '6 M', '9 M', '1 Y', '18 M', '2 Y', '3 Y', '4 Y', '5 Y', '7 Y', '10 Y', '15 Y', '20 Y', '30 Y'];
export const currencyTerms = ['1 D', '3 D', '1 W', '2 W', '1 M', '2 M', '3 M', '6 M', '9 M', '1 Y'];
export const currencyLSTerms = ['1 D', '2 D', '3 D', '4 D', '5 D', '1 W', '2 W', '3 W', '1 M', '2 M', '3 M', '4 M', '5 M', '6 M', '7 M', '8 M', '9 M', '10 M', '11 M', '12 M'];
export const bondLevels = ['Price', 'Spread', 'Yield', 'IG'];

export const daysByDayNumber = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
};
export const dropDownStyle = {
    control: (provided, state) => ({
        ...provided,
        background: '#FE9628',
        borderWidth: '0px',
        borderColor: 'none',
        cursor: 'pointer',
        boxShadow: 'none',
        width: '136px',
        minHeight: '28px',
        padding: '0px 14px',
        borderRadius: '6px',
        '&:active': {
            borderColor: '#2962FF'
        },
        '.select2-selection__single-value': {
            fontSize: '12px',
            fontWeight: '600',
            color: '#000'
        },
        '.select2-selection__value-container': {
            padding: '0'
        },
        '.select2-selection__indicator': {
            width: '15px'
        },
        '.select2-selection__input': {
            color: '#000 !important',
            '.select2-selection__input::placeholder': {
                color: '#000 !important'
            }
        },
        '.select2-selection__multi-value': {
            background: '#1E222D',
            color: '#fff',
            padding: '4px 8px;',
            marginRight: '4px 6px',
            '.select2-selection__multi-value__label': {
                color: '#fff',
                padding: '0',
                marginRight: '8px',
                fontSize: '12px',
                lineHeight: '16px'
            },
            '.select2-selection__multi-value__remove': {
                padding: 0,
                '&:hover': {
                    background: 'none',
                    color: '#fff'
                }
            }
        }

    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 50,
        backgroundColor: '#1E222D'

    }),

    option: (provided) => ({
        ...provided,
        color: '#868993',
        fontSize: '12px',
        backgroundColor: '#1E222D',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#2A2E39',
            color: '#D1D4DC'
        }
    }),

    valueContainer: (provided) => ({
        ...provided,
        height: '100%',
        padding: '0 12px'

    }),

    placeholder: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
        color: '#000',
        fontSize: '12px',
        lineHeight: '16px'
    }),

    input: (provided) => ({
        ...provided,
        margin: '0px',
        fontSize: '12px'
    }),
    indicators: () => ({
        width: '15px'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: '100%'
    }),
    clearIndicator: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: '-7px',
        backgroundColor: 'red',
        padding: '2px',
        right: '-4px',
        borderRadius: '100px',
        fontSize: '10px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '15px',
        height: '15px',
        '&:hover': {
            color: '#000',
            padding: '1px'
        }
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: '#000',
        padding: ' 0',
        strokeWidth: '5px',
        marginTop: '3px',
        '&:hover': {
            color: '#000'
        }
    })
};
export const selectCustomStyles = {
    control: (provided, state) => ({
        ...provided,
        background: '#FD9626',
        borderWidth: '0px',
        borderColor: 'none',
        cursor: 'pointer',
        boxShadow: 'none',
        width: '74px',
        minHeight: '32px',
        borderRadius: '6px',
        '&:active': {
            borderColor: '#2962FF'
        },
        '.select2-selection__single-value': {
            fontSize: '14px',
            fontWeight: '600',
            color: '#000',
            textAlign: 'right'
        },
        '.select2-selection__input': {
            color: '#000 !important',
            '.select2-selection__input::placeholder': {
                color: '#000 !important'
            }
        },
        '.select2-selection__multi-value': {
            background: '#1E222D',
            color: '#fff',
            padding: '4px 8px;',
            marginRight: '4px 6px',
            '.select2-selection__multi-value__label': {
                color: '#fff',
                padding: '0',
                marginRight: '8px',
                fontSize: '12px',
                lineHeight: '16px'
            },
            '.select2-selection__multi-value__remove': {
                padding: 0,
                '&:hover': {
                    background: 'none',
                    color: '#fff'
                }
            }
        }

    }),
    menu: (provided) => ({
        ...provided,

        backgroundColor: '#1E222D'

    }),

    option: (provided) => ({
        ...provided,
        color: '#868993',
        fontSize: '12px',
        backgroundColor: '#1E222D',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#2A2E39',
            color: '#fff'
        }
    }),

    valueContainer: (provided) => ({
        ...provided,
        height: '100%',
        padding: '0 0 0 12px'

    }),

    placeholder: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
        color: '#fff',
        fontSize: '12px',
        lineHeight: '16px'
    }),

    input: (provided) => ({
        ...provided,
        margin: '0px',
        fontSize: '12px'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: '100%'
    }),
    clearIndicator: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: '-7px',
        backgroundColor: 'red',
        padding: '2px',
        right: '-4px',
        borderRadius: '100px',
        fontSize: '10px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '15px',
        height: '15px',
        '&:hover': {
            color: '#000',
            padding: '1px'
        }
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: '#000',
        padding: '4px 8px 4px 2px'

    })
};

export const priceBlinkDuration = 15 * 1000; // 15 seconds
export const priceGreyOutDuration = 60 * 1000; // 60 seconds

export const bondStatus = {
    DEFAULTED: 'DEFAULTED',
    LIVE: 'LIVE',
    CALLED: 'CALLED',
    MATURED: 'MATURED'
};

export const livePriceRoutes = ['/liveprices', '/liveprices/macro', '/liveprices/bonds', '/liveprices/[type]'];
export const isHootDisabled = false;
export const isChatDisabled = false;

export const customTimeOption = ({ secondarystyle = false } = {}) => <div className={`flex ${secondarystyle ? '!text-sm' : 'text-xs'} gap-x-1 items-center`}>
    {secondarystyle ? 'Good Till Cancel' : 'GTC (Good Till Cancel)'}
    <div className={`group ${!secondarystyle ? 'hidden' : ''} relative time-limit-tooltip`}>
        <AlertCircle size={secondarystyle ? 15 : 13} className='text-gray-200 cursor-pointer group-hover:text-gray-100' />
        <div className={`bg-gray-700 rounded-md p-2 z-[9999] absolute hidden group-hover:block cursor-pointer fx ${secondarystyle ? 'contextMenu-gtc' : 'time-tooltip-text'}  normal-case text-left `}>
            <Text variant="small" className="text-gray-100">Good Till Cancel - The price is live till you cancel it,
                or else it will automatically be deleted at 12:00 noon SGT for the morning session and 6:00 PM SGT for the afternoon session.</Text>
        </div>
    </div>
</div >;
export const timeLimitOptions = [
    { id: 1, value: 60, label: 'Go live for 1 min' }, { id: 2, value: 120, label: 'Go live for 2 mins' },
    { id: 3, value: 600, label: 'Go live for 10 mins' },
    { id: 4, value: 3600, label: 'Go live for 1 hour' }, { id: 5, value: 0, label: customTimeOption() }];

export const priorityOrder = [
    'QuickCurrency',
    'Bond',
    'Irs',
    'Ndf',
    'Cds',
    'Vol',
    'Equity',
    'Currency',
    'MaturedBond'
];

export const globalCommandOptions = ({ bondType, role }) => [{
    category: 'Functions',
    items: [{
        command: 'PLOT',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Plot',
        html: <div>
            Plot Graph{' '}
            <span className="text-gray-200">
                &lt;curvename&gt; &lt;tenor(s)&gt; (Eg: INR NDOIS 3Y 5Y 7Y) (Eg: INR NDF 1M 2M) (Eg: INDON 5Y 10Y)
            </span>
        </div>
    },
    {
        command: 'CTASCAN',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Regress',
        html: <div> CTA Signal Scanner</div>
    },
    {
        command: 'REGRESS',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Regress',
        html: <div> REGRESS IRS STRUCTURE 1 Vs IRS STRUCTURE 2</div>
    },
    {
        command: 'THOR',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Regress',
        html: <div> THOR - IRS Structure 1 Vs IRS Structure 2</div>
    },
    {
        command: 'BASIS',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Plot IRS curves',
        html: <div>BASIS STRUCTURE 1 Vs STRUCTURE 2</div>
    },
    {
        command: 'ANCHOR',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Anchor',
        html: <div>Optimal Hedge Discovery</div>
    },
    {
        command: 'ROLL',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Roll',
        html: <div>
            Plot Graph{' '}
            <span className="text-gray-200">
                &lt;curvename&gt; &lt;tenor(s)&gt; (Eg: INR NDOIS 5Y 10Y) (Eg: INR NDOIS U5 Z5 5Y 10Y)
            </span>
        </div>
    },
    {
        command: 'FWCM',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'FWCM',
        html: <div>
            Forward Curve Matrix{' '}
            <span className="text-gray-200">
                &lt;curve name&gt; (Eg: FWCM INR NDOIS, FWCM AUD IRS)
            </span>
        </div>
    },
    {
        command: 'EDGE',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'EDGE',
        html: <div>
            Enhanced Differential Grid Engine
        </div>
    },
    {
        command: 'INP',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Inp',
        html: <div>
            Input form{' '}
            <span className="text-gray-200">
                {bondType === 'IRS' ? (
                    <>
                        &lt;Curve name&gt; &lt;Start date&gt; &lt;Tenor(s)&gt; &lt;Size&gt; &lt;DV01/Notional&gt;
                        &lt;B/O&gt; (Eg: KRW NDIRS spot 1M 12M 3k 9.6b)
                    </>
                ) : (
                    <>
                        &lt;Curve name&gt; &lt;Tenor(s)&gt; &lt;Notional&gt; &lt;B/O&gt; (Eg: KRW NDF 1W 1Y 5Mn 5.6b)
                    </>
                )}
            </span>
        </div>
    },
    {
        command: 'CORP',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Corp',
        html: <div>
            Shows all bonds with a specified ticker{' '}
            <span className="text-gray-200">
                (Eg: CORP INDON, INDON CORP, INDON &lt;F3 | enter&gt;)
            </span>
        </div>
    },
    {
        command: 'OTC',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Otc',
        html: <div>
            Over-the-counter{' '}
            <span className="text-gray-200">
                &lt;Currency&gt; (Eg: OTC INR, OTC NZD)
            </span>
        </div>
    },
    {
        command: 'SHARE', type: 'Function', group: 'Functions', label: 'Share Screen Image'
    },
    {
        command: 'TOP', type: 'Function', group: 'Functions', label: 'Top News'
    },
    {
        command: 'CN', type: 'Function', group: 'Functions', label: 'Company News'
    },
    {
        command: 'TRADES', type: 'Function', group: 'Functions', label: 'All Trades'
    },
    {
        command: 'TRSY', type: 'Function', group: 'Functions', label: 'TRSY'
    },
    {
        command: 'GP', type: 'Function', group: 'Functions', label: 'Line Chart'
    },
    {
        command: 'HP', type: 'Function', group: 'Functions', label: 'Price History'
    },
    {
        command: 'BXT',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'BXT',
        html: <div>
            Buy Trade{' '}
            <span className="text-gray-200">
                &lt;Curve name&gt; &lt;Start date&gt; &lt;Tenor(s)&gt; (Eg: KRW NDIRS spot 1m)
            </span>
        </div>
    },
    {
        command: 'SXT',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'SXT',
        html: <div>
            Sell Trade{' '}
            <span className="text-gray-200">
                &lt;Curve name&gt; &lt;Start date&gt; &lt;Tenor(s)&gt; (Eg: KRW NDIRS spot 1m)
            </span>
        </div>
    },
    {
        command: 'MEET',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'meet',
        html: <div>
            Meeting Dates
        </div>
    },
    {
        command: 'OVDV',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Ovdv',
        html: <div>
            Volatility Surface{' '}
            <span className='text-gray-200'>
                &lt;Currency Pair&gt; (Eg;  OVDV USDINR, OVDV INRUSD, OVDV INR)
            </span>
        </div>
    },
    {
        command: 'OMON',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Omon',
        html: <div>
            Options Monitor{' '}
            <span className='text-gray-200'>
                OMON &lt;Currency&gt;, OMON &lt;Currency Pair&gt; (Eg: OMON SGD, OMON USDSGD)
            </span>
        </div>
    },
    {
        command: 'DSLICE',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Dslice',
        html: <div>
            Options Strip at Constant Delta{' '}
        </div>
    },
    {
        command: 'DES', type: 'Function', group: 'Functions', label: 'Instrument Details'
    },
    {
        command: 'ATLAS', type: 'Function', group: 'Functions', label: 'Advanced Trade & Liquidity Analysis System'
    },
    {
        command: 'ARC', type: 'Function', group: 'Functions', label: 'Advanced Rate Curvature Analysis'
    },
    {
        command: 'TRACE',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'TRACE',
        html: <div>
            Search Any Structure Across Time
        </div>
    },
    {
        command: 'CURVE',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'CURVE',
        html: <div>
            Spot & Forward Curve Viewer{' '}
            <span className='text-gray-200'>
                &lt;Curve Name&gt; (Eg: INR NDOIS)
            </span>
        </div>
    },
    {
        command: 'PLOTF',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Plotf',
        html: <div>
            Plot Future Graph{' '}
            <span className="text-gray-200">
                &lt;curvename&gt; &lt;tenor(s)&gt; (eg: INR NDOIS 1Y) (Eg: INR NDOIS 1Y 2Y)
            </span>
        </div>
    },
    {
        command: 'PLOTA',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Plotf',
        html: <div>
            Plot Advanced Graph{' '}
            <span className="text-gray-200">
                &lt;curvename&gt; &lt;tenor(s)&gt; (eg: INR NDOIS 1Y) (Eg: INR NDOIS 1Y 5Y)
            </span>
        </div>
    },
    {
        command: 'STATS',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'Stats',
        html: <div>
            ATLAS Trades Tenor Breakdown {' '}
            <span className='text-gray-200'>
                STATS &lt;Curvename&gt;
            </span>
        </div>
    },
    {
        command: '6s3s',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: '6s3s',
        html: <div>
            Semi-Annual Vs Quarterly Curve Basis{' '}
            <span className='text-gray-200'>
                &lt;Structure&gt;
            </span>
        </div>
    },
    {
        command: 'BOB',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'BOB',
        html: <div>
            Bills-OIS Basis{' '}
            <span className='text-gray-200'>
                &lt;Structure&gt;
            </span>
        </div>
    },
    {
        command: 'WATCHLIST',
        type: 'Function',
        group: 'Functions',
        formattingStyle: 'html',
        label: 'WATCHLIST',
        html: <div>
            IRS Structure Watchlist{' '}
            <span className="text-gray-200">
                WATCHLIST &lt;enter&gt;
            </span>
        </div>
    }
    ].filter((cmd) => {
        if (!role) return true;
        if (['BXT', 'SXT', 'MAPPING'].includes(cmd.command)) {
            return role === 'Broker';
        }
        return true;
    })
}];

export const fxClosingTimeOptions = [
    { value: 'T', label: 'TOKYO' }, // defualt
    { value: 'NY', label: 'NY' },
    { value: 'LDN', label: 'LDN' }
];

export const fxClosingTimeFormatter = {
    generic: {
        T: '15:00 Tokyo',
        NY: '10:00 New York',
        LDN: ''
    }
};

export const fxTradeTypeOptions = [
    { value: 'vanilla', label: 'Vanilla', enabled: true }, // defualt
    { value: 'rr', label: 'RR', enabled: false },
    { value: 'butterfly', label: 'Butterfly', enabled: false }
];

export const strDelReverseType = {
    strike: 'delta',
    delta: 'strike'
};

const createCommandDetailsMapping = (bond, isBond, isEquity) => ({
    DES: `${bond} Details`,
    GP: `${bond} History Plot`,
    HP: `${bond} Price History`,
    YAS: `${bond} Yield Analysis`,
    CN: `${bond} ${isBond ? 'Company News' : 'News'}`,
    GIP: `${bond} Intraday ${isEquity ? 'Trading Chart' : 'Price Chart'}`,
    TOP: 'Top News',
    TRADES: 'All Trades'
});

export const getBlurb = ({
    bond, command, isBond = false, isEquity = false
}) => {
    if (!bond) return '';
    if (!command) return `${bond} Details`;

    return createCommandDetailsMapping(bond, isBond, isEquity)[command] ?? '';
};

export const extractBondBlurb = (bond) => {
    const parts = String(bond ?? '').split(' ');
    const bondName = parts[0];

    const datePart = parts.find((part) => (part.match(/\//g) || []).length === 2);
    if (!datePart) return bondName;

    const maturityYear = datePart.split('/').pop();

    return `${bondName} ${maturityYear}`;
};

export const bondBasicDropdownStyle = {
    ...commonDropdownStyle,
    control: (provided, state) => ({
        ...commonDropdownStyle.control(provided, state),
        background: '#FE9628',
        width: '100%',
        padding: '0px 14px',
        borderRadius: '0px',
        '.select2-selection__single-value': {
            ...commonDropdownStyle.control(provided, state)['.select2-selection__single-value'],
            fontWeight: '600',
            color: '#000'
        }
    }),
    placeholder: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
        color: '#000',
        fontSize: '12px',
        lineHeight: '16px'
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: '#000',
        padding: '0',
        strokeWidth: '5px',
        marginTop: '3px',
        '&:hover': {
            color: '#000'
        }
    })
};

export const fxOptionEnum = {
    CALL: 'Call',
    PUT: 'Put',
    ATM_STR: 'AtmStraddle',
    ATMF_STR: 'AtmfStraddle',
    RR: 'RiskReversal'
};

export const optionTypeFormatter = {
    [fxOptionEnum.CALL]: 'Call',
    [fxOptionEnum.PUT]: 'Put',
    [fxOptionEnum.ATM_STR]: 'ATM',
    [fxOptionEnum.ATMF_STR]: 'ATMF',
    [fxOptionEnum.RR]: 'RR'
};

export const fxOptionProps = {
    Call: {
        label: 'CALL',
        value: 'Call',
        tradeLabel: 'CALL',
        strikeLabel: null,
        color: '!text-warning-500',
        form: { label: 'CALL', ipLabel: null, buttonTheme: 'success' }
    },
    Put: {
        label: 'PUT',
        value: 'Put',
        tradeLabel: 'PUT',
        strikeLabel: null,
        color: '!text-error-300',
        form: { label: 'PUT', ipLabel: null, buttonTheme: 'danger' }
    },
    AtmStraddle: {
        label: 'STR',
        value: 'AtmStraddle',
        tradeLabel: 'STRADDLE',
        strikeLabel: 'ATM',
        color: '!text-others-100',
        form: { label: 'ATM STRADDLE', ipLabel: 'ATM', buttonTheme: 'neutral' }
    },
    AtmfStraddle: {
        label: 'STR',
        value: 'AtmfStraddle',
        tradeLabel: 'STRADDLE',
        strikeLabel: 'ATMF',
        color: '!text-others-150',
        form: { label: 'ATMF', ipLabel: 'ATMF', buttonTheme: 'pink' }
    }
};
export const atmDeltaValue = 50;

export const premiumTypeOptions = {
    FORWARD: { label: 'Forward Premium', value: 'forward' },
    SPOT: { label: 'Spot Premium', value: 'spot' }
};

export const parseFXOInput = (text, globalCommand = false) => {
    if (!text || text?.toLowerCase()?.includes('plot')) return { isValid: false };
    const closingTimes = ['TOK', 'NY', 'LDN'];
    const optionTypes = {
        c: 'Call', call: 'Call', p: 'Put', put: 'Put', atm: 'AtmStraddle', atmstruddle: 'AtmStraddle'
    };
    const bidOfferTypes = {
        b: 'Bid', bid: 'Bid', o: 'Offer', ofr: 'Offer', offer: 'Offer'
    };
    const notionalPattern = /\b\d+(Mn|Mm|Mio)\b/i;
    const deltaPattern = /\b(\S+)Del\b/i;
    const strikePattern = /^\d+(\.\d+)?$/;
    const levelPattern = /^(\d+(\.\d+)?)vol$/i;
    const currencyPairPattern = /^[A-Z]{6}$/i;

    const startsWithINP = text.toUpperCase().startsWith('INP');
    if (globalCommand && !startsWithINP) return { isValid: false };
    const parts = startsWithINP ? text.slice(3).trim().split(/\s+/) : text.trim().split(/\s+/);

    const result = {
        currencyPair: null,
        optionType: null,
        closingTime: null,
        expiry: null,
        isExpiryCustom: false,
        delta: null,
        strike: null,
        notional: null,
        volatility: null,
        type: 'Bid',
        isValid: false
    };

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        if (!result.currencyPair && currencyPairPattern.test(part.toUpperCase())) {
            result.currencyPair = part.toUpperCase();
        } else if (!result.optionType && optionTypes[part.toLowerCase()]) {
            result.optionType = optionTypes[part.toLowerCase()];
        } else if (!result.closingTime && closingTimes.includes(part.toUpperCase())) {
            result.closingTime = part.toUpperCase();
        } else if (!result.delta && deltaPattern.test(part)) {
            result.delta = part.match(deltaPattern)[1].replace(/[^0-9.]/g, '');
            result.fixedPosition = 'delta';
        } else if (!result.strike && strikePattern.test(part)) {
            result.strike = part.replace(/[^0-9.]/g, '');
            result.fixedPosition = 'strike';
        } else if (!result.notional && notionalPattern.test(part)) {
            result.notional = part.replace(/[^0-9.]/g, '');
        } else if (!result.volatility && levelPattern.test(part)) {
            result.volatility = part.match(levelPattern)[1].replace(/[^0-9.]/g, '');
        } else if (bidOfferTypes[part.toLowerCase()]) {
            result.type = bidOfferTypes[part.toLowerCase()];
        } else if (!result.expiry) {
            if (part.length === 2 && /^([hmuzHMUZ])/.test(part)) result.expiry = part;
            if (part.length >= 2) {
                if (/([dwmyDWMY])$/.test(part) && !Number.isNaN(Number(part.substring(0, part.length - 1)))) {
                    result.expiry = part;
                } else {
                    const pSet = part.split('/');
                    if (pSet.length === 3 && pSet.reduce((acc, curr) => acc && Number.isNaN(Number(curr)), true)) {
                        result.expiry = part;
                        result.isExpiryCustom = true;
                    }
                }
            }
        }
    }

    if (result.delta) {
        result.strike = null;
    }

    result.isValid = !!result.currencyPair;

    return result;
};

export const parseBxtSxtInput = (text, validImm = []) => {
    if (!text?.trim()) return { isValid: false };

    const upper = text.trim().toUpperCase();
    if (!upper.startsWith('BXT') && !upper.startsWith('SXT')) {
        return { isValid: false };
    }

    const reservedStartPattern = /^(spot|[HMUZhmuz]\d{1,2})$/i;
    const tenorPattern = /^\d+[mywd]$/i;
    const twoTenorsNoSepPattern = /^(\d+[mywd])(\d+[mywd])$/i;
    const compactStartTenorPattern = /^([HMUZhmuz]\d{1,2})(\d+[mywd])$/i;
    const spreadPattern = /^\d+[mywd]x\d+[mywd]$/i;
    const dv01Pattern = /^\d+k$/i;
    const pricePattern = /^\d+(\.\d+)?(o|b|p|r|bid|offer|pay|rec|receive)?$/i;
    const sizePattern = /^\d+(k|mn|mm|mio)$/i;
    const traderPattern = /^[\w\s-]+$/;

    const result = {
        command: upper.split(/\s+/)[0],
        curveName: null,
        start: null,
        tenors: [],
        dv01s: [],
        sizes: [],
        price: null,
        trader: null,
        isFwd: false,
        hasSpreadDiffStartDate: false,
        spreadDiffStartData: null,
        starts: [],
        ends: []
    };

    const parts = text.slice(3).trim().split(/\s+/);

    const curveName = [];
    let remainingParts = [];

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        if (
            reservedStartPattern.test(part)
            || tenorPattern.test(part)
            || spreadPattern.test(part)
            || dv01Pattern.test(part)
            || pricePattern.test(part)
            || sizePattern.test(part)
            || twoTenorsNoSepPattern.test(part)
            || compactStartTenorPattern.test(part)
        ) {
            remainingParts = parts.slice(i);
            break;
        }

        curveName.push(part);
    }

    result.curveName = curveName.length > 0 ? curveName.join(' ') : null;

    const tenorTokensAfterCurve = remainingParts.slice();

    const gluedPairs = [];
    const parseDiffStartPairToken = (token = '') => {
        const mTenorTenor = token.match(twoTenorsNoSepPattern);
        if (mTenorTenor) {
            return { start: mTenorTenor[1].toLowerCase(), end: mTenorTenor[2].toLowerCase() };
        }
        const mImmTenor = token.match(compactStartTenorPattern);
        if (mImmTenor) {
            return { start: mImmTenor[1].toUpperCase(), end: mImmTenor[2].toLowerCase() };
        }
        return null;
    };

    for (let i = 0; i < remainingParts.length; i++) {
        const token = remainingParts[i];
        const low = token?.toLowerCase() ?? '';

        if (dv01Pattern.test(token) || pricePattern.test(token) || sizePattern.test(low)) break;

        const parsed = parseDiffStartPairToken(token);
        if (parsed) gluedPairs.push(parsed);
    }

    const uniqueStarts = [...new Set(gluedPairs.map((p) => p.start))];
    if (gluedPairs.length >= 2 && uniqueStarts.length >= 2) {
        const pairA = gluedPairs[0];
        const pairB = gluedPairs[1];

        const startToYears = (s) => {
            if (!s) return 0;
            if (isImmDate(String(s).trim().toUpperCase())) {
                return tenorToYears(convertImmToYear(String(s).trim().toUpperCase(), validImm));
            }
            return tenorToYears(s);
        };
        const maturity = (p) => startToYears(p.start) + tenorToYears(p.end);

        const [first, second] = maturity(pairA) >= maturity(pairB)
            ? [pairB, pairA]
            : [pairA, pairB];

        const spreadDiffStartData = {
            endLabel: first.end,
            end1Label: second.end,
            startLabel: first.start,
            start1Label: second.start,
            type: BOND_TYPE_ENUM.SPREAD_DIFF_START_DATE
        };

        result.isFwd = true;
        result.hasSpreadDiffStartDate = true;
        result.spreadDiffStartData = spreadDiffStartData;

        result.starts = [spreadDiffStartData.startLabel, spreadDiffStartData.start1Label];
        result.ends = [spreadDiffStartData.endLabel, spreadDiffStartData.end1Label];

        result.start = spreadDiffStartData.startLabel;
        result.tenors = [spreadDiffStartData.endLabel, spreadDiffStartData.end1Label];

        remainingParts = remainingParts.slice(gluedPairs.length);
    }

    if (remainingParts.length > 0) {
        const first = remainingParts[0];
        const compactStartTenorMatch = first.match(compactStartTenorPattern);
        const combinedMatch = first.match(twoTenorsNoSepPattern);

        if (compactStartTenorMatch) {
            const start = compactStartTenorMatch[1].toUpperCase();
            const nextTenor = compactStartTenorMatch[2].toLowerCase();

            result.isFwd = true;
            result.start = start;

            if (!result.tenors.some((t) => t.toLowerCase() === nextTenor)) {
                result.tenors.push(nextTenor);
            }

            remainingParts = remainingParts.slice(1);
        } else if (combinedMatch) {
            const start = combinedMatch[1].toUpperCase();
            const nextTenor = combinedMatch[2].toLowerCase();

            result.isFwd = true;
            result.start = start;

            if (!result.tenors.some((t) => t.toLowerCase() === nextTenor)) {
                result.tenors.push(nextTenor);
            }

            remainingParts = remainingParts.slice(1);
        }
    }

    for (let i = 0; i < remainingParts.length; i++) {
        const part = remainingParts[i];
        const partLower = part.toLowerCase();

        if ((partLower === 'fwd' || partLower === 'f') && i - 1 >= 0 && i + 1 < remainingParts.length) {
            const prev = remainingParts[i - 1];
            const next = remainingParts[i + 1];

            if (tenorPattern.test(prev) && tenorPattern.test(next)) {
                result.isFwd = true;
                result.start = prev.toUpperCase();

                const prevLower = prev.toLowerCase();
                result.tenors = result.tenors.filter((t) => t.toLowerCase() !== prevLower);

                const nextLower = next.toLowerCase();

                if (!result.tenors.some((t) => t.toLowerCase() === nextLower)) {
                    result.tenors.push(nextLower);
                }

                i += 1;
                continue;
            }
        }

        // detect combined tenors (spread / butterfly legs)
        const compactStartTenorMatch = part.match(compactStartTenorPattern);
        const combinedMatch = part.match(twoTenorsNoSepPattern);

        if (compactStartTenorMatch) {
            const start = compactStartTenorMatch[1].toUpperCase();
            const nextTenor = compactStartTenorMatch[2].toLowerCase();

            result.isFwd = true;

            if (!result.start) {
                result.start = start;
            }

            if (result.start === start) {
                if (!result.tenors.some((t) => t.toLowerCase() === nextTenor)) {
                    result.tenors.push(nextTenor);
                }
            }

            continue;
        }

        if (combinedMatch) {
            const start = combinedMatch[1].toUpperCase();
            const nextTenor = combinedMatch[2].toLowerCase();

            result.isFwd = true;

            if (!result.start) {
                result.start = start;
            }

            if (result.start === start) {
                if (!result.tenors.some((t) => t.toLowerCase() === nextTenor)) {
                    result.tenors.push(nextTenor);
                }
            }

            continue;
        }

        if (reservedStartPattern.test(part)) {
            const upper = part.toUpperCase();
            if (upper !== 'SPOT') {
                const isKnownImm = validImm.some(
                    (e) => e.label.toUpperCase() === upper
                        || e.oldLabel?.toUpperCase() === upper
                );
                if (!isKnownImm) return { isValid: false };
            }
            result.start = upper;
        } else if (spreadPattern.test(part)) {
            const [t1, t2] = part.toLowerCase().split('x');

            if (!result.tenors.some((t) => t.toLowerCase() === t1)) {
                result.tenors.push(t1);
            }

            if (!result.tenors.some((t) => t.toLowerCase() === t2)) {
                result.tenors.push(t2);
            }
        } else if (tenorPattern.test(part)) {
            const t = part.toLowerCase();

            if (!result.tenors.some((x) => x.toLowerCase() === t)) {
                result.tenors.push(t);
            }
        } else if (dv01Pattern.test(part)) {
            result.dv01s.push(part);
        } else if (pricePattern.test(part)) {
            result.price = part;
        } else if (sizePattern.test(partLower)) {
            result.sizes.push(part);
        } else if (
            !reservedStartPattern.test(part)
            && !tenorPattern.test(part)
            && !spreadPattern.test(part)
            && !dv01Pattern.test(part)
            && !pricePattern.test(part)
            && !sizePattern.test(partLower)
            && traderPattern.test(part)
        ) {
            const traderTokens = [];
            let traderEndIndex = i;

            for (let j = i; j < remainingParts.length; j++) {
                const token = remainingParts[j];
                const tokenLower = token.toLowerCase();

                if (
                    reservedStartPattern.test(token)
                    || tenorPattern.test(token)
                    || spreadPattern.test(token)
                    || dv01Pattern.test(token)
                    || pricePattern.test(token)
                    || sizePattern.test(tokenLower)
                    || tokenLower === 'fwd'
                    || tokenLower === 'f'
                    || twoTenorsNoSepPattern.test(token)
                    || compactStartTenorPattern.test(token)
                ) {
                    break;
                }

                traderTokens.push(token);
                traderEndIndex = j;
            }

            if (traderTokens.length > 0) {
                result.trader = traderTokens.join(' ');
            }

            i = traderEndIndex;
        }
    }

    if (result.tenors.length > 0) {
        const formattedTenors = result.tenors.map((tenor) => {
            const value = tenor.replace(/(\d+)\s*([a-zA-Z])/, (_, number, unit) => `${number} ${unit.toUpperCase()}`);
            return value === '12 M' ? '1 Y' : value;
        });

        const unitOrder = ['D', 'W', 'M', 'Y'];

        const sortedTenors = formattedTenors.sort((a, b) => {
            const [numA, unitA] = a.split(' ');
            const [numB, unitB] = b.split(' ');

            const unitComparison = unitOrder.indexOf(unitA) - unitOrder.indexOf(unitB);

            if (unitComparison !== 0) return unitComparison;

            return parseInt(numA, 10) - parseInt(numB, 10);
        });

        result.tenors = sortedTenors;
    }

    const isLoneTenorToken = (p) => tenorPattern.test(p)
        && !twoTenorsNoSepPattern.test(p)
        && !compactStartTenorPattern.test(p);
    const isGluedTenorToken = (p) => twoTenorsNoSepPattern.test(p)
        || compactStartTenorPattern.test(p);
    if (
        tenorTokensAfterCurve.some(isLoneTenorToken)
        && tenorTokensAfterCurve.some(isGluedTenorToken)
    ) {
        return { isValid: false };
    }

    return { isValid: true, ...result };
};

export const dateBtnList = [
    { id: 0, label: 'Today', date: new Date() },
    { id: 1, label: 'Tom', date: moment(new Date()).add(1, 'day').toDate() },
    { id: 2, label: 'Spot', date: new Date() },
    { id: 3, label: '1D', date: moment(new Date()).add(1, 'day').toDate() },
    { id: 4, label: '2D', date: moment(new Date()).add(2, 'day').toDate() },
    { id: 5, label: '3D', date: moment(new Date()).add(3, 'day').toDate() },
    { id: 6, label: '1W', date: moment(new Date()).add(1, 'weeks').toDate() },
    { id: 7, label: '2W', date: moment(new Date()).add(2, 'weeks').toDate() },
    { id: 8, label: '3W', date: moment(new Date()).add(3, 'weeks').toDate() },
    { id: 9, label: '1M', date: moment(new Date()).add(1, 'month').toDate() },
    { id: 10, label: '2M', date: moment(new Date()).add(2, 'month').toDate() },
    { id: 11, label: '3M', date: moment(new Date()).add(3, 'month').toDate() },
    { id: 12, label: '6M', date: moment(new Date()).add(6, 'month').toDate() },
    { id: 13, label: '9M', date: moment(new Date()).add(9, 'month').toDate() },
    { id: 14, label: '1Y', date: moment(new Date()).add(1, 'year').toDate() },
    { id: 15, label: '2Y', date: moment(new Date()).add(2, 'year').toDate() },
    { id: 16, label: '3Y', date: moment(new Date()).add(3, 'year').toDate() },
    { id: 17, label: '5Y', date: moment(new Date()).add(5, 'year').toDate() }
];

export const calcNonPremCurrency = (currencyPair) => {
    const premCurr = currencyPair?.premiumCurrency?.toUpperCase();
    if (!premCurr || currencyPair.ticker.startsWith(premCurr)) return currencyPair.ticker.substring(3);
    return currencyPair.ticker.substring(0, 3);
};

export const convertSizeToNumber = (value) => {
    const lower = value.toLowerCase();

    if (lower.endsWith('k')) {
        return parseFloat(lower) * 1_000;
    }
    if (lower.endsWith('mio') || lower.endsWith('mn') || lower.endsWith('mm')) {
        return parseFloat(lower) * 1_000_000;
    }
    if (!isNaN(Number(value))) {
        return Number(value);
    }

    return 0; // or throw error if needed
};
export const getUserStatus = (timestamp, isUserOnline, isBioPage = false) => {
    if (isUserOnline) return 'online';
    if (!timestamp || typeof timestamp.toDate !== 'function') return 'offline';

    const lastSeenDate = timestamp.toDate();
    const now = new Date();
    const diffMs = now - lastSeenDate;
    const diffMinutes = diffMs / (1000 * 60);

    const idleCondition = isBioPage ? 43200 : 30;

    if (diffMinutes <= 5) return 'online';
    if (diffMinutes <= idleCondition) return 'idle';
    return 'offline';
};

export const getUserHootStatus = (timestamp, isUserOnline) => {
    if (isUserOnline === 'online') return 'online';
    if (!timestamp || typeof timestamp.toDate !== 'function') return 'offline';

    const lastSeenDate = timestamp.toDate();
    const now = new Date();
    const diffMs = now - lastSeenDate;
    const diffMinutes = diffMs / (1000 * 60);

    if (diffMinutes <= 5) return 'idle';
    return 'offline';
};

export const getStatusClass = (status) => {
    if (status === 'online') return 'success-300';
    if (status === 'idle') return 'warning-300';
    return 'gray-300';
};

export const formatSDRDv01Val = (val) => {
    const num = Number(val);
    if (isNaN(num)) return val ?? '';

    const absVal = Math.abs(num);
    let value; let
        unit = '';

    if (absVal >= 1e9) {
        value = num / 1e9;
        unit = 'Bn';
    } else if (absVal >= 1e6) {
        value = num / 1e6;
        unit = 'Mn';
    } else if (absVal >= 1e3) {
        value = num / 1e3;
        unit = 'K';
    } else {
        value = num;
    }

    const rounded = Number(value.toFixed(1));

    return `${rounded}${unit}`;
};

const EPS = 1e-9;
export const isMultipleOf = (v, base) => Math.abs(v / base - Math.round(v / base)) < EPS;

export const PAGE_KEYS = {
    ATLAS: 'atlas',
    THOR: 'thor',
    ANCHOR: 'anchor',
    OMON: 'omon',
    DSLICE: 'dslice',
    STATS: 'stats',
    WATCHLIST: 'watchlist',
    CTA: 'ctascan',
    CTAEQ: 'ctaEquity'
};

export const PREFERENCE_KEYS = {
    TAB: 'tab',
    COLUMN: 'column',
    MID_PRICE: 'mid-price',
    MID_VIEW: 'mid-view',
    SECONDARY_METRIC: 'secondary-metric',
    HEATMAP_VS: 'heatmap-vs',
    OPTION_TYPE: 'option-type',
    TENOR_BUCKETS: 'is-tenor-buckets',
    ROW_ORDER: 'row-order',
    CTA_EQ_TICKER: 'cta-eq-ticker',
    CTA_SEC_TYPE: 'cta-sec-type'
};

export const OMON_DATE_RANGE_OPTIONS = [
    { label: '1D', value: '1D' },
    { label: '2D', value: '2D' },
    { label: '3D', value: '3D' },
    { label: '4D', value: '4D' },
    { label: '5D', value: '5D' },
    { label: '6D', value: '6D' },
    { label: '7D', value: '7D' },
    { label: '9D', value: '9D' },
    { label: '10D', value: '10D' },
    { label: '3W', value: '3W' },
    { label: '1M', value: '1M' },
    { label: '2M', value: '2M' },
    { label: '3M', value: '3M' },
    { label: '4M', value: '4M' },
    { label: '5M', value: '5M' },
    { label: '6M', value: '6M' },
    { label: '7M', value: '7M' },
    { label: '8M', value: '8M' },
    { label: '9M', value: '9M' },
    { label: '10M', value: '10M' },
    { label: '11M', value: '11M' },
    { label: '1Y', value: '1Y' },
    { label: '2Y', value: '2Y' }
];

export const OMON_MID_PRICE_OPTIONS = [
    { label: 'Forward', value: 'forward' },
    { label: 'Spot', value: 'spot' }
];

export const DSLICE_MID_VIEW_OPTIONS = [
    { label: 'bps', value: 'bps' },
    { label: 'vol %', value: 'perc' }
];

export const DSLICE_HEATMAP_VS = [
    { label: 'Vs ATM', value: 'atm', color: '#008069' },
    { label: 'Vs 3M', value: '3m', color: '#008069' }
];

export const DSLICE_OPTION_TYPE = [
    { label: 'CALL', value: fxOptionEnum.CALL, color: '#289A3F' },
    { label: 'PUT', value: fxOptionEnum.PUT, color: '#DC2020' }
];

export const fwdSpreadTypes = ['fSpread', 'fBfly', 'fBflyDiff', 'fSpreadDiff'];

export const CURVE_TENORS = [
    {
        id: 'spot',
        label: 'Spot',
        colorClass: 'text-warning-200',
        color: '#FD9626'
    },
    {
        id: '3m',
        label: '3M FWD',
        colorClass: 'text-graph-100',
        color: '#2CAFFE'
    },
    {
        id: '6m',
        label: '6M FWD',
        colorClass: 'text-graph-200',
        color: '#544FC5'
    },
    {
        id: '1y',
        label: '1Y FWD',
        colorClass: 'text-graph-300',
        color: '#91E8E1'
    },
    {
        id: '2y',
        label: '2Y FWD',
        colorClass: 'text-graph-400',
        color: '#F5AF67'
    },
    {
        id: '3y',
        label: '3Y FWD',
        colorClass: 'text-graph-500',
        color: '#FA4B42'
    },
    {
        id: '5y',
        label: '5Y FWD',
        colorClass: 'text-graph-600',
        color: '#2EE0CA'
    },
    {
        id: '7y',
        label: '7Y FWD',
        colorClass: 'text-graph-700',
        color: '#D568FB'
    },
    {
        id: '10y',
        label: '10Y FWD',
        colorClass: 'text-graph-800',
        color: '#6B8ABC'
    },
    {
        id: '15y',
        label: '15Y FWD',
        colorClass: 'text-graph-900',
        color: '#FE6A35'
    },
    {
        id: '20y',
        label: '20Y FWD',
        colorClass: 'text-graph-1000',
        color: '#00E272'
    },
    {
        id: '30y',
        label: '30Y FWD',
        colorClass: 'text-graph-1100',
        color: '#93C47D'
    }
];

export const OUTRIGHT_TENORS = [
    { id: '1M', label: '1M', color: '#FFA07A' },
    { id: '3M', label: '3M', color: '#FFD700' },
    { id: '6M', label: '6M', color: '#FFED4E' },
    { id: '9M', label: '9M', color: '#C6FF00' },
    { id: '1Y', label: '1Y', color: '#76FF03' },
    { id: '2Y', label: '2Y', color: '#4ECDC4' },
    { id: '3Y', label: '3Y', color: '#45B7AA' },
    { id: '5Y', label: '5Y', color: '#2A8E7E' },
    { id: '7Y', label: '7Y', color: '#2CAFFE' },
    { id: '10Y', label: '10Y', color: '#0D47A1' },
    { id: '15Y', label: '15Y', color: '#5A6FBA' },
    { id: '20Y', label: '20Y', color: '#9B59B6' },
    { id: '25Y', label: '25Y', color: '#AF79C4' },
    { id: '30Y', label: '30Y', color: '#C9A2E0' }
];

export const SPREAD_TENORS = [
    { id: '1Yx2Y', label: '1Yx2Y', color: '#FF6B6B' },
    { id: '1Yx3Y', label: '1Yx3Y', color: '#FF8E72' },
    { id: '1Yx5Y', label: '1Yx5Y', color: '#FFB347' },
    { id: '1Yx7Y', label: '1Yx7Y', color: '#FFC870' },
    { id: '1Yx10Y', label: '1Yx10Y', color: '#FFD700' },
    { id: '2Yx3Y', label: '2Yx3Y', color: '#4ECDC4' },
    { id: '2Yx5Y', label: '2Yx5Y', color: '#3CA291' },
    { id: '2Yx7Y', label: '2Yx7Y', color: '#338D78' },
    { id: '2Yx10Y', label: '2Yx10Y', color: '#2A785F' },
    { id: '3Yx4Y', label: '3Yx4Y', color: '#95E1D3' },
    { id: '3Yx5Y', label: '3Yx5Y', color: '#82D8CE' },
    { id: '3Yx7Y', label: '3Yx7Y', color: '#6FCFC9' },
    { id: '3Yx10Y', label: '3Yx10Y', color: '#5CC6C4' },
    { id: '4Yx5Y', label: '4Yx5Y', color: '#C44569' },
    { id: '4Yx7Y', label: '4Yx7Y', color: '#D45B7A' },
    { id: '4Yx10Y', label: '4Yx10Y', color: '#E07188' },
    { id: '5Yx7Y', label: '5Yx7Y', color: '#667BC6' },
    { id: '5Yx10Y', label: '5Yx10Y', color: '#5A6FBA' },
    { id: '5Yx15Y', label: '5Yx15Y', color: '#4E63AE' },
    { id: '7Yx10Y', label: '7Yx10Y', color: '#DA70D6' },
    { id: '7Yx15Y', label: '7Yx15Y', color: '#E291E8' },
    { id: '10Yx15Y', label: '10Yx15Y', color: '#F4A5F0' }
];

export const BUTTERFLY_TENORS = [
    { id: '1Yx2Yx3Y', label: '1Yx2Yx3Y', color: '#6C5CE7' },
    { id: '1Yx3Yx5Y', label: '1Yx3Yx5Y', color: '#7D3C98' },
    { id: '2Yx3Yx5Y', label: '2Yx3Yx5Y', color: '#8E44AD' },
    { id: '2Yx5Yx10Y', label: '2Yx5Yx10Y', color: '#9B59B6' },
    { id: '3Yx5Yx7Y', label: '3Yx5Yx7Y', color: '#A569BD' },
    { id: '3Yx7Yx10Y', label: '3Yx7Yx10Y', color: '#AF79C4' },
    { id: '5Yx7Yx10Y', label: '5Yx7Yx10Y', color: '#B989CB' },
    { id: '5Yx10Yx30Y', label: '5Yx10Yx30Y', color: '#00B4DB' },
    { id: '7Yx10Yx20Y', label: '7Yx10Yx20Y', color: '#0083B0' },
    { id: '10Yx20Yx30Y', label: '10Yx20Yx30Y', color: '#005A87' }
];

export const normalize = (t) => {
    if (t === 'Spot') { return { termWithSpace: '0 Y', termNoSpace: '0Y' }; }
    const m = String(t).trim().toUpperCase().match(/^(\d+)([YMWD])$/i);
    if (!m) return { termNoSpace: t.replace(/\s/g, ''), termWithSpace: t };
    const n = m[1];
    const u = m[2].toUpperCase();
    return {
        termNoSpace: `${n}${u}`,
        termWithSpace: `${n} ${u === 'M' ? 'M' : (u === 'Y' ? 'Y' : u)}`
    };
};

export const tenorToYears = (tenorStr) => {
    if (!tenorStr) return 0;
    const normalized = String(tenorStr).trim().toUpperCase().replace(/\s+/g, '');
    const match = normalized.match(/^(\d+(?:\.\d+)?)([YMWD])$/i);
    if (!match) return 0;

    const value = parseFloat(match[1]);
    const unit = match[2].toUpperCase();

    switch (unit) {
        case 'Y':
            return value;
        case 'M':
            return value / 12;
        case 'W':
            return value / 52;
        case 'D':
            return value / 365;
        default:
            return null;
    }
};

export const plotSyntaxInfo = [
    {
        heading: 'Single tenor',
        title: 'PLOT 5Y',
        description: 'Adds the spot 5-year point.',
        title2: 'PLOT 10Y',
        description2: 'Plots the historical 10-year rate.'
    },
    {
        heading: 'Spread',
        title: 'PLOT 2Y 5Y',
        description: 'Adds the 2s5s spread.',
        title2: 'PLOT 10Y 5Y',
        description2: 'Plots the 5s10s spread.'
    },
    {
        heading: 'Butterfly',
        title: 'PLOT 2Y 5Y 10Y',
        description: 'Adds a 2s5s10s butterfly structure.'
    },
    {
        heading: 'Forward-starting rate',
        title: 'PLOT 2Y2Y',
        description: 'Plots the 2-year forward 2-year rate.',
        title2: 'PLOT 3Y5Y',
        description2: 'Plots the 3-year forward 5-year rate.'
    },
    {
        heading: 'Forward-start spread',
        title: 'PLOT 1Y fwd 2Y 5Y',
        description: 'Spread with same forward start.',
        title2: 'PLOT 2Y3Y 4Y6Y',
        description2: 'Spread with different forward starts.'
    },
    {
        heading: 'Forward-start butterfly',
        title: 'PLOT 1Y fwd 2Y 5Y 10Y',
        description: 'Forward-start butterfly.',
        title2: 'PLOT 1Y3Y 2Y5Y 3Y7Y',
        description2: 'Butterfly with different forward starts.'
    },
    {
        heading: 'IMM forwards',
        title: 'PLOT M6 1Y',
        description: 'M6 forward 1Y.',
        title2: 'PLOT M6 1Y 2Y',
        description2: 'M6 forward 1s2s spread.',
        title3: 'PLOT M6 1Y 3Y 5Y',
        description3: 'M6 forward 1s3s5s butterfly.'
    }
];

/** PLOTA floating prompt — context-switching examples only (syntax guide). */
export const plotAdvanceSyntaxInfo = [
    {
        heading: '2Y2Y <ENTER>',
        description: 'Adds the 2Y2Y forward on the currently active curve.'
    },
    {
        heading: 'KRW NDIRS <ENTER> -> 2Y5Y <ENTER>',
        description: 'Switches context to the KRW NDIRS curve, then overlays the 2y5y structure.'
    },
    {
        heading: 'USD SOFR <ENTER> -> 1Y1Y <ENTER> -> 3Y3Y <ENTER>',
        description: 'Switches to the USD SOFR curve and adds multiple structures sequentially.'
    }
];
export const isSpreadStructure = (structureRaw = '') => {
    const structure = structureRaw.trim().toUpperCase();
    if (!structure) return false;

    const normalized = structure
        .replace(/,/g, ' ')
        .replace(/X/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const fwdMatches = normalized.match(
        /([A-Z0-9]+)\s+FWD\s+(\d+(?:\.\d+)?[DWMY])/g
    ) || [];

    let remaining = normalized;
    fwdMatches.forEach((fwd) => {
        remaining = remaining.replace(fwd, '').trim();
    });

    const standaloneTenors = remaining
        .split(' ')
        .filter((t) => /^\d+(?:\.\d+)?[DWMY]$/.test(t));

    const totalLegs = fwdMatches.length + standaloneTenors.length;

    return totalLegs > 1;
};

export const BOND_TYPE_ENUM = {
    SPREAD_DIFF_START_DATE: 'spreadDiffStartDates',
    MEETING_DATES: 'meetingDates',
    BOB_OUTRIGHT: 'bobOutright',
    BOB_SPREAD: 'bobSpread',
    BOB_SPREAD_DIFF_START_DATE: 'bobSpreadDiffStartDates',
    BOB_BUTTERFLY: 'bobButterfly',
    SIXS_OUTRIGHT: '6s3sOutright',
    SIXS_SPREAD: '6s3sSpread',
    SIXS_SPREAD_DIFF_START_DATE: '6s3spreadDiffStartDates',
    SIXS_BUTTERFLY: '6s3sButterfly'
};

export const formatSpreadDiffStartLabel = (
    startA = '',
    endA = '',
    startB = '',
    endB = ''
) => {
    const normalize = (v = '') => v.toUpperCase().replace(/\s+/g, '');

    const formatOne = (start, end) => {
        const normStart = normalize(start);
        const normEnd = normalize(end);

        if (isImmDate(start)) {
            return `${normStart} - ${normEnd}`;
        }

        const hasCustom = isCustomDate(start) || isCustomDate(end);

        return `${normStart}${hasCustom ? ' ' : ''}${normEnd}`;
    };
    return `${formatOne(startA, endA)} X ${formatOne(startB, endB)}`;
};

export const buildSpreadDiffStartDateLegs = ({ legs, imm }) => {
    const mapImm = (i) => {
        const y = parseFloat(String(i).match(/\d+(?:\.\d+)?/)?.[0]);
        const found = imm?.find((im) => im.y === y);
        return found ? found.label : i;
    };

    const pairA = {
        start: mapImm(legs.l1),
        end: legs.l2,
        startInYear: legs.l1
    };

    const pairB = {
        start: mapImm(legs.l3),
        end: legs.l4,
        startInYear: legs.l3
    };

    const maturity = (p) => tenorToYears(p.startInYear) + tenorToYears(p.end);

    const [first, second] = maturity(pairA) >= maturity(pairB)
        ? [pairB, pairA]
        : [pairA, pairB];

    return {
        endLabel: addSpaceBeforeUnit(first.end),
        end1Label: addSpaceBeforeUnit(second.end),
        startLabel: addSpaceBeforeUnit(first.start),
        start1Label: addSpaceBeforeUnit(second.start),
        type: BOND_TYPE_ENUM.SPREAD_DIFF_START_DATE
    };
};

export const convertImmToYear = (label, imm = [], shouldAddSpace = false) => {
    if (!label) return '0 Y';

    const normalized = String(label).trim().toUpperCase().replace(/\s+/g, '');

    const found = imm.find((im) => im.label?.toUpperCase() === normalized);

    if (found) {
        return `${found?.y} Y`;
    }
    if (!shouldAddSpace) {
        return normalized;
    }
    const match = normalized.match(/^(\d+)([A-Z]+)$/);

    if (match) {
        return `${match[1]} ${match[2]}`;
    }

    return label;
};
export const getEndDate = (startDate, termOrImm, imm = []) => {
    if (isImmDate(termOrImm)) {
        termOrImm = convertImmToYear(termOrImm, imm);
    }

    function addSpaceBetweenNumberAndUnit(value = '') {
        return value.replace(/^(\d+(?:\.\d+)?)([A-Za-z]+)$/, '$1 $2');
    }

    termOrImm = addSpaceBetweenNumberAndUnit(String(termOrImm).trim());
    const isStandardTerm = termOrImm.match(
        /^(\d+(?:\.\d+)?)(?:\s*)([dwmyDWMY])$/
    );

    if (!isStandardTerm) {
        return new Date(moment(termOrImm, 'YYYY-MM-DD'));
    }

    const [, duration, unit] = isStandardTerm;

    const units = {
        m: addMonths,
        y: addYears,
        w: addWeeks,
        d: addDays
    };

    const adder = units[unit.toLowerCase()];

    return adder(startDate, parseFloat(duration));
};

export const isIrsBobCurve = (bondType) => {
    if (!bondType) return false;
    return [BOND_TYPE_ENUM.BOB_OUTRIGHT, BOND_TYPE_ENUM.BOB_SPREAD, BOND_TYPE_ENUM.BOB_SPREAD_DIFF_START_DATE, BOND_TYPE_ENUM.BOB_BUTTERFLY].includes(bondType);
};

export const isIrs6s3sCurve = (bondType) => {
    if (!bondType) return false;
    return [BOND_TYPE_ENUM.SIXS_OUTRIGHT, BOND_TYPE_ENUM.SIXS_SPREAD, BOND_TYPE_ENUM.SIXS_SPREAD_DIFF_START_DATE, BOND_TYPE_ENUM.SIXS_BUTTERFLY].includes(bondType);
};

export const isCustomDate = (str) => /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{2})$/.test(str);

export const parseDate = (date) => {
    if (!date) return null;
    if (moment.isMoment(date)) return date;
    if (date instanceof Date) return moment(date);
    return moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);
};

export const isWithinTolerance = (expected, actual, tolerance = 1) => {
    const expectedMoment = parseDate(expected)?.startOf('day');
    const actualMoment = parseDate(actual)?.startOf('day');
    if (!expectedMoment?.isValid() || !actualMoment?.isValid()) return false;
    return Math.abs(actualMoment.diff(expectedMoment, 'days')) <= tolerance;
};

export const isDateLabel = (label) => {
    if (!label) return false;
    return moment(label, ['DD/MM/YY', 'DD/MM/YYYY', 'YYYY-MM-DD'], true).isValid();
};

export const addSpaceBeforeUnit = (value) => {
    if (!value) return value;

    return value
        .trim()
        .replace(/\s+/g, ' ')
        .replace(/^(\d*\.?\d+)\s*([DdMmYyWw])$/, (_, num, unit) => `${num} ${unit.toUpperCase()}`);
};

export const IRS_RAIL_BUTTON_LIST = [
    {
        section: "Visualize",
        items: [
            { id: "plot", name: "PLOT", command: "PLOT", icon: Activity, hoverText: 'PLOT - Single Curve' },
            { id: "plota", name: "PLOTA", command: "PLOTA", icon: TrendUp, hoverText: 'PLOTA - Multi Curve Overlay' },
            { id: "basis", name: "BASIS", command: "BASIS", icon: Minus, hoverText: 'BASIS - Spread Vs Benchmark' },
            { id: "regr", name: "REGR", command: "REGRESS", icon: Diagram, hoverText: 'REGR - Regression Analysis' },
        ],
    },
    {
        section: "Analytics",
        items: [
            { id: "anchor", name: "ANCHOR", command: "ANCHOR", icon: Anchor, hoverText: 'ANCHOR - Optimal Hedge Discovery' },
            { id: "arc", name: "ARC", command: "ARC", icon: Chart, hoverText: 'ARC - Roll and Carry Analysis' },
            { id: "trace", name: "TRACE", command: "TRACE", icon: StatusUp, hoverText: 'TRACE - Trade Prints' },
            { id: 'edge', name: 'EDGE', command: 'EDGE', icon: Category, hoverText: 'EDGE - Cross Grid Regression' },
            { id: 'cta', name: 'CTASCAN', command: 'CTASCAN', icon: Speedometer, hoverText: 'CTASCAN - CTA Signal Scanner' }
        ],
    },
    // {
    //     section: "Workspace",
    //     items: [
    //         { id: "hist", name: "HIST", command: "HIST", icon: Clock },
    //         { id: "favs", name: "FAVS", command: "FAVS", icon: Star },
    //     ],
    // },
];

export const ctaEquityTickers = [
    { ticker: 'GSPC.INDX', name: 'S&P 500', displayTicker: 'SPX' },
    { ticker: 'NDX.INDX', name: 'Nasdaq 100', displayTicker: 'NDX' },
    { ticker: 'QQQ.US', name: 'Invesco Nasdaq', displayTicker: 'QQQ' },
    { ticker: 'DJI.INDX', name: 'Dow Jones', displayTicker: 'DJI' },
    { ticker: 'IWM.US', name: 'Russel 2000', displayTicker: 'IWM' }
];

export const ctaSectorPriority = {
    'EM ASIA': 0,
    G10: 1
};
